import React from 'react';
import "../common.css";
import skills from "../../Skills/skills.json";
import credentials from "../../Credentials/credentials.json";

const SplashScreen = (props) => {
    let subheading;
    const filterList = Object.keys(credentials).map((key) => {
        return (
            <div className='major_cr' onClick={()=> document.getElementById(key)?.scrollIntoView()}>{key}</div>
        )
    })
    let element = <img className='splash_photo' src={process.env.PUBLIC_URL + props.photo} alt='experiences' />;
    if (props.name === "Experiences") {
        element = <div className='mskills center'>
            <img className='major_img' src={process.env.PUBLIC_URL + "/assets/experiences/q1.jpg"} />
            <img className='major_img' src={process.env.PUBLIC_URL + "/assets/experiences/q2.jpg"} />
            <img className='major_img' src={process.env.PUBLIC_URL + "/assets/experiences/q3.jpg"} />
            <img className='major_img' src={process.env.PUBLIC_URL + "/assets/experiences/q4.jpg"} />
            <img className='major_img' src={process.env.PUBLIC_URL + "/assets/experiences/q5.jpg"} />
            <img className='major_img' src={process.env.PUBLIC_URL + "/assets/experiences/q6.jpg"} />
            <img className='major_img' src={process.env.PUBLIC_URL + "/assets/experiences/q7.jpg"} />
            <img className='major_img' src={process.env.PUBLIC_URL + "/assets/experiences/q8.jpg"} />
        </div>
        subheading = "From managing high-throughput distributed systems at CHTC for CERN and LIGO to leading microservices architecture development and automated cloud provisioning, I have driven improvements in system performance, scalability, and efficiency. These roles, along with my involvement in sports, have sharpened my skills and prepared me for future tech industry challenges.";
    }
    else if (props.name === "Credentials") {
        element = <div className='mskills center' >
            {[filterList]}
                </div>
        subheading = "Pursuing a Bachelor's in Computer Science with minors in Data Science and Mathematics from UW-Madison, I have deepened my expertise through advanced coursework, hands-on projects, and certifications from AWS, IBM, and Coursera. My focus on algorithms, machine learning, software engineering, and cloud computing reflects my commitment to continuous learning and staying at the forefront of technology.";
    }
    else if (props.name === "Projects") {
        element = <div className='mskills center'>
                    <div className='major_pr' onClick={()=> document.getElementById("Distributed Systems and Cloud Infrastructure")?.scrollIntoView()}>
                        Distributed Systems and Cloud Infrastructure 
                    </div>
                    <div className='major_pr' onClick={()=> document.getElementById("Full-Stack Web Application and Software Engineering")?.scrollIntoView()}>
                        Full-Stack Web Application and Software Engineering
                    </div>
                    <div className='major_pr' onClick={()=> document.getElementById("Data Science and Machine Learning")?.scrollIntoView()}>
                        Data Science and Machine Learning
                    </div>
                </div>
        subheading = "My projects reflect my commitment to solving real-world problems through innovative technology solutions - hands on exprience is the only way to truly understand topics and concepts. Each project has taught me valuable lessons in full-stack development, cloud computing, and data analysis, enhancing my ability to drive impactful results and adapt to new challenges in the tech industry.";
    }
    else if (props.name === "Skills") {
        const majorSkills = Object.keys(skills).map((skill) => {
            return <div onClick={()=> document.getElementById(skill)?.scrollIntoView()} className='major_skill'>
                    {skill}
                </div>
        })
        element = <div className='mskills center'>
            {[majorSkills]}
                </div>
        subheading = "View the complete list of skills that I bring to the table. I have acquired and honed them over the course of many years, through academic coursework, hands-on projects, and professional experiences.";
    }
    else {
        subheading = null;
    }

    return (
        <div className='splashscreen center' style={{backgroundColor: props.bgColor, color: props.color}}>
            <div className='splash_title flex_column'>
                {props.name}
                <div className='splash_sub'>
                    {subheading}
                </div>
            </div>
            {element}
        </div>
    )
}

export default SplashScreen;